@if (attachments().length) {
  <div class="mt-2 flex flex-wrap gap-2">
    @for (attachment of attachments(); track attachment.key) {
      <a
        [href]="attachment.url"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-2 rounded-lg border border-gray-200 dark:border-zinc-700 px-2 py-1 text-xs text-primary hover:bg-gray-50 dark:hover:bg-zinc-800"
      >
        @if (isImage(attachment.fileType)) {
          <img [src]="attachment.url" [alt]="attachment.fileName" class="h-8 w-8 rounded object-cover" />
        }
        <span class="max-w-[10rem] truncate">{{ attachment.fileName }}</span>
      </a>
    }
  </div>
}
